<template>
    <div class="time-selector">
        <v-menu :close-on-content-click="false">
            <template v-slot:activator="{ props }">
                <v-text-field clearable
                              class="ma-0 pa-0"
                              variant="outlined"
                              density="compact"
                              v-bind="props"
                              v-model="time"
                              :label="label"
                              type="text"
                              prepend-inner-icon="mdi-clock-time-eight-outline" />
            </template>

            <v-list>
                <v-list-item>
                    <TimePicker v-model="time"
                                :color="primaryColor" />
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
    import { DateTime } from "luxon";

    import { TimePicker } from "vue-material-time-picker";
    import "vue-material-time-picker/dist/style.css";

    export default {
        components: {
            TimePicker
        },

        props: {
            modelValue: String,
            label: String
        },

        emits: ["update:modelValue"],

        data() {
            return {
                time: this.modelValue
            };
        },

        computed: {
            theme() {
                return this.$vuetify.theme;
            },
            themeName() {
                return this.theme.global.name;
            },
            currentTheme() {
                return this.theme.themes[this.themeName];
            },
            primaryColor() {
                return this.currentTheme.colors.primary;
            }
        },

        watch: {
            modelValue() {
                this.time = this.modelValue;
            },

            time(newValue) {
                this.time = this.getValidTime(newValue);
                this.update(this.time);
            }
        },

        methods: {
            getValidTime(inputValue) {
                if (!inputValue) {
                    return "";
                }
                if (typeof inputValue !== "string") {
                    return "";
                }

                let value = inputValue.trim();

                if (value.length !== 5) {
                    return "";
                }

                if (value[2] === "ж"
                    || value[2] === "Ж"
                    || value[2] === ";") {
                    value = value.substring(0, 2) + ":" + value.substring(3, 5);
                }

                if (value[2] !== ":") {
                    return "";
                }

                const hh = value.substring(0, 2);
                const mm = value.substring(3, 5);

                if (hh === "HH" && mm === "mm") {
                    return "";
                }
                if (hh === "HH") {
                    return "00:" + mm;
                }
                if (mm === "mm") {
                    return hh + ":00";
                }

                return value;
            },

            isValidTime(time) {
                const dateTime = DateTime.fromISO(time);

                return dateTime.isValid;
            },

            update(time) {
                this.$emit("update:modelValue", time);
            }
        }
    };
</script>

<style lang="scss">
    .time-selector {
        width: 150px;
    }

    .time-selector .v-input__details {
        display: none;
    }
</style>